import {takeLatest,call,all,put} from 'redux-saga/effects'
import userTypes from './user.types'
import {signInSuccess,signOutSuccess, userError} from './user.actions'
import { auth, getCurrentUser, handleUserProfile,GoogleProvider } from '../../components/Firebase/utils';

export function* getSnapshotFromUserAuth(user) {
try{
    const userRef = yield call(handleUserProfile,{userAuth:user})
    const snapshot = yield userRef.get()
    yield put(signInSuccess({
        id:snapshot.id,
        ...snapshot.data()
    }))
    }catch(err)
    {

    }
}
export function* isUserAuthenticated() {
try{
    const userAuth = yield getCurrentUser()
    if(!userAuth) return
    yield getSnapshotFromUserAuth(userAuth)
}catch(err)
{
    console.log(err)
}
}
export function* onCheckUserSession()
{
    yield takeLatest(userTypes.CHECK_USER_SESSION, isUserAuthenticated)
}
export function* emailSignIn({payload:{email,password}})
{
    try {
       const {user} =  yield auth.signInWithEmailAndPassword( email, password);
       yield getSnapshotFromUserAuth(user)
    
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
}
export function* onEmailSignInStart() {
    yield takeLatest(userTypes.EMAIL_SIGN_IN_START,emailSignIn)
}
export function* signOutUser() {
    try {
      yield auth.signOut().then(window.location.href="/")
      yield put(
        signOutSuccess()
      )
  
    } catch (err) {
      // console.log(err);
    }
  }
export function* onSignOutUserStart() {
    yield takeLatest(userTypes.SIGN_OUT_START, signOutUser);
  }
export function* signUpUser({ payload: {
    displayName,
    email,
    password,
    confirmPassword
  } }) {
  
    if (password !== confirmPassword) {
      const err = ['Password Don\'t match'];
      yield put(
        userError(err)
      )
      return
    }
  
    try {
      const { user } = yield auth.createUserWithEmailAndPassword(email, password)
      const additionalData = { displayName };
      yield getSnapshotFromUserAuth(user, additionalData);
  
    } catch (err) {
      console.log(err);
    }
  
  }
export function* onSignUpStart() {
   yield takeLatest(userTypes.SIGN_UP_START,signUpUser)
}
export function* googleSignIn() {
  try {
    const { user } = yield auth.signInWithPopup(GoogleProvider);
    yield getSnapshotFromUserAuth(user);

  } catch (err) {
    // console.log(err);
  }
}

export function* onGoogleSignInStart() {
  yield takeLatest(userTypes.GOOGLE_SIGN_IN_START, googleSignIn);
}
export  default function* userSagas() {
    yield all([call(onEmailSignInStart),call(onCheckUserSession),call(onSignOutUserStart),call(onSignUpStart),call(onGoogleSignInStart)])
}